import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from '@mode/capra';
import { PlanCardComponent } from '../plan-card/plan-card.component';

@Component({
  selector: 'mode-enterprise-plan',
  standalone: true,
  imports: [CommonModule, IconComponent, PlanCardComponent],
  templateUrl: './enterprise-plan.component.html',
  styleUrls: ['./enterprise-plan.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EnterprisePlanComponent {
  public readonly planFeatures: readonly string[] = [
    'Unlimited users',
    '10GB/query',
    '1500GB monthly throughput',
    'Admin-level API access',
    'Enterprise support',
  ];
  @Input() isUpgradePlansFlow = false;
}
